import { StarIcon } from '@phosphor-icons/react';

import styles from './star-rating.module.scss';

/** Read-only 5-star display; `value` is 0..5 (rounded). `isRated` (default `true`) controls only
 *  the accessible name: an unrated item must never announce "Rated 0 out of 5" — a real zero-star
 *  rating a screen reader cannot distinguish from "not yet rated" — so it announces "Not yet rated"
 *  instead while still rendering the same unfilled stars visually. */
export function StarRating({ value, isRated = true }: { value: number; isRated?: boolean }) {
  const filled = Math.round(value);
  const label = isRated ? `Rated ${filled} out of 5` : 'Not yet rated';
  return (
    <span className={styles.stars} role="img" aria-label={label}>
      {Array.from({ length: 5 }, (_, i) => {
        const on = i < filled;
        return (
          <StarIcon
            key={i}
            data-testid="star"
            data-filled={on}
            size={28}
            weight={on ? 'fill' : 'regular'}
            className={on ? styles.on : styles.off}
            aria-hidden
          />
        );
      })}
    </span>
  );
}
